
import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
// import Navbar from './Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import SignUp from './UIElements/authentication/SignUp'
import ForgotPassword from './UIElements/authentication/ForgotPassword';
import ValidateCode from './UIElements/authentication/ValidateCode';
import SignIn from './UIElements/authentication/SignIn';
import VerifyEmail from './UIElements/authentication/VerifyEmail';
import UpdatePassword from './UIElements/Settings/UpdatePassword';
import Profile from './UIElements/Settings/Profile';
import Settings from './UIElements/Settings/Setting';
import SettingsMobile from './UIElements/Settings/SettingsMobile';
import Home from './UIElements/Home/Home';
import Logs from './UIElements/Logs/Logs';
import LogsMobileUI from './UIElements/Logs/logsMobileUI'
import Users from './UIElements/Users/Users';
import Navbar from './UIElements/Navbar/Navbar';
import NavbarMobileUI from './UIElements/Navbar/NavbarMobileUI';
import './UIElements/Navbar/NavbarMobile.css';
import UsersMobileUI from './UIElements/Users/UsersMobileUI';
import ClientDetails from './UIElements/Details/ClientDetails';
import ProfileMobile from './UIElements/Settings/ProfileMobile';
import UpdatePasswordMobile from './UIElements/Settings/UpdatePasswordMobile';
import AccessDenied from './UIElements/AccessDenied/AccessDenied';
import HomeMobileUI from './UIElements/Home/HomeMobileUI';
import ClientDetailsMobileUI from './UIElements/Details/ClientDetailsMobileUI';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });
  const [username, setUsername] = useState('');
  const location = useLocation();
  const accessLevel = localStorage.getItem("accessLevel");
  const UserStatus = localStorage.getItem("UserStatus");

  console.log('testing log', UserStatus);
  const [isMobile, setIsMobile] = useState(false);

  // useEffect(() => {
  //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  //   // Check if the user is on a mobile device
  //   const isMobileDevice = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  //   setIsMobile(isMobileDevice);
  // }, []);

  useEffect(() => {
    const detectMobileDevice = () => {
      const userAgent = typeof window !== "undefined" ? navigator.userAgent : "";
      return /Mobi|Android|iPhone|iPad/i.test(userAgent);
    };

    // Function to check screen width
    const handleResize = () => {
      setIsMobile(detectMobileDevice() || window.innerWidth <= 768); // Set based on device or screen width
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize); // Listen for screen resize

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup
    };
  }, []);

  useEffect(() => {
    const noSelectElements = document.querySelectorAll('.App');
    noSelectElements.forEach((element) => {
      element.style.webkitUserSelect = 'none';
      element.style.mozUserSelect = 'none';
      element.style.msUserSelect = 'none';
      element.style.userSelect = 'none';
    });
    console.log('testing log');

    // Check remembered login status but don't reset isLoggedIn automatically
    if (!isLoggedIn && localStorage.getItem('rememberMe') === 'true') {
      const rememberedEmail = localStorage.getItem('rememberedEmail');
      const rememberedPassword = localStorage.getItem('rememberedPassword');

      if (rememberedEmail && rememberedPassword) {
        setUsername(rememberedEmail);
      }
    }

  }, [location.pathname, isLoggedIn]);




  const handleLogin = (username) => {
    setIsLoggedIn(true);
    setUsername(username);
    localStorage.setItem('isLoggedIn', 'true');

  };

  const handleSignout = () => {
    const domain = "https://us-east-1z0mtkhk91.auth.us-east-1.amazoncognito.com";
    const clientId =process.env.REACT_APP_COGNITO_CLIENTID;
    const logoutRedirectUri = "https://refer.sharkunlock.com/logout"; // or your local URI
    //const logoutRedirectUri = "http://localhost:3000/logout"; // or your production URI

    if (localStorage.getItem('rememberMe') !== 'true') {
      localStorage.clear();
    } else {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('accessLevel');
    }

    setIsLoggedIn(false);
    setUsername('');

    // Redirect to Cognito logout endpoint
    window.location.href = `${domain}/logout?client_id=${clientId}&logout_uri=${logoutRedirectUri}`;
  };


  return (
    <div className={`App ${isLoggedIn ? 'logged-in' : ''}`}>


      {isLoggedIn ? (<>
        {isMobile ? (<NavbarMobileUI username={username} onSignout={handleSignout} />) : (
          <Navbar username={username} onSignout={handleSignout} />
        )}
        <div className={isMobile ? 'mbl-maincontent' : 'maincontent'}>

          <Routes>

            {isMobile ? (
              <>

                <Route path="/Referrals" element={<HomeMobileUI />} />
                <Route path="/logs" element={<LogsMobileUI />} />
                <Route path="/Users" element={<UsersMobileUI />} />
                <Route path="/details" element={<ClientDetailsMobileUI />} />


                {UserStatus !== 'EXTERNAL_PROVIDER' && (
                  <>
                    <Route path="/Settings" element={<SettingsMobile />}>
                      <Route path="Profile" element={<ProfileMobile />} />
                      <Route path="UpdatePassword" element={<UpdatePasswordMobile />} />
                    </Route>
                  </>
                )}

              </>
            ) :
              (<>


                <Route path="/Referrals" element={<Home />} />
                <Route path="/Logs" element={<Logs />} />
                <Route path="/Users" element={<Users />} />
                <Route path="/details" element={<ClientDetails />} />


                {UserStatus !== 'EXTERNAL_PROVIDER' && (
                  <>
                    <Route path="/Settings" element={<Settings />}>
                      <Route path="Profile" element={<Profile />} />
                      <Route path="UpdatePassword" element={<UpdatePassword />} />
                    </Route>
                  </>
                )}


              </>
              )}
            <Route path="*" element={<Navigate to="/Referrals" />} />
          </Routes>
        </div>
      </>
      ) : (
        <Routes>

          {isMobile ? (
            <>
              <Route path="/" element={<SignIn onLogin={handleLogin} />} />
              <Route path="/SignUp" element={<SignUp onLogin={handleLogin} />} />
              <Route path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/ValidateCode" element={<ValidateCode />} />
              <Route path="/VerifyEmail" element={<VerifyEmail />} />
              <Route path="/AccessDenied" element={<AccessDenied onSignout={handleSignout} />} />

            </>
          ) : (
            <>
              <Route path="/" element={<SignIn onLogin={handleLogin} />} />
              <Route path="/SignUp" element={<SignUp onLogin={handleLogin} />} />
              <Route path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/ValidateCode" element={<ValidateCode />} />
              <Route path="/VerifyEmail" element={<VerifyEmail />} />
              <Route path="/AccessDenied" element={<AccessDenied onSignout={handleSignout} />} />

            </>
          )}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      )}

    </div>
  );
}

export default App;
